import React, { FC } from 'react'
import { Typography, Flex } from 'antd'

const { Text } = Typography

interface PlatformChipProps {
  label: string
  icon?: string
  color: string
  activeBackground: string
  active: boolean
  onClick: () => void
}

const PlatformChip: FC<PlatformChipProps> = ({ label, icon, color, activeBackground, active, onClick }) => (
  <Flex
    align='center'
    gap={6}
    onClick={onClick}
    style={{
      height: 35,
      borderRadius: 2,
      padding: '0 12px',
      border: '1px solid #D9D9D9',
      background: active ? activeBackground : '#FAFAFA',
      cursor: 'pointer',
      opacity: active ? 1 : 0.55,
      userSelect: 'none',
    }}
  >
    {icon && <img src={icon} alt={label} style={{ width: 16, height: 16 }} />}
    <Text style={{ fontFamily: 'Roboto', fontWeight: 400, fontSize: 14, lineHeight: '22px', color: active ? color : '#8c8c8c' }}>
      {label}
    </Text>
  </Flex>
)

export default PlatformChip
